<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group :submissionId="submissionId" />
      <div v-if="samples && samples.length">
        <hr />
        <template v-for="(sample, index) in samples">
          <project-waste-sample-form-group
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            :addOns="addOns"
            @updateSampleList="updateSampleList"
          />
        </template>
      </div>
      <b-row class="my-3" align-h="end">
        <b-col cols="2">
          <b-button @click="updateSampleList('add')" variant="success" block>
            <i class="fa fa-plus" /> Add Sample
          </b-button>
        </b-col>
      </b-row>
      <turn-around-select
        :submissionId="submissionId"
        :turnArounds="turnArounds"
      />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question
            :key="index"
            :serviceQuestion="question"
          />
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import ProjectWasteSampleFormGroup from "./ProjectWasteSampleFormGroup";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectWasteSubmissionForm",
  components: {
    ProjectFieldFormGroup,
    ProjectWasteSampleFormGroup,
    TurnAroundSelect
  },
  props: {
    submissionId: {
      type: String,
      default: ""
    },
    serviceQuestions: {
      type: Array,
      default: () => []
    },
    turnArounds: {
      type: Array,
      default: () => []
    },
    addOns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission"
    }),
    current_submission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.current_submission.samples;
    }
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field
      });
    },
    updateSampleList(action, id) {
      const lastSample = this.samples[this.samples.length - 1];
      let listUpdate;
      switch (action) {
        case "add":
          listUpdate = [
            ...this.samples,
            {
              ...lastSample,
              test_package_sample_id: this.$uuid.v4(),
              identifier: `Sample ${this.samples.length + 1}`,
              add_ons: [...lastSample.add_ons]
            }
          ];
          break;
        case "remove":
          listUpdate = this.samples.filter(
            sample => sample.test_package_sample_id !== id
          );
          break;
        default:
      }
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: listUpdate,
        name: "samples"
      });
    }
  }
};
</script>
